import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  NavbarContainer,
  NavLinks,
  NavLink,
  BurgerMenu,
  MobileMenu,
  MobileNavLink,
} from "./styles";

const Navbar: React.FC = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef<HTMLDivElement | null>(null);

  // Expose la hauteur réelle du header en CSS var --nav-h
  useLayoutEffect(() => {
    const setNavVar = () => {
      const h = headerRef.current?.offsetHeight ?? 56;
      document.documentElement.style.setProperty("--nav-h", `${h}px`);
    };
    setNavVar();
    window.addEventListener("resize", setNavVar);
    return () => window.removeEventListener("resize", setNavVar);
  }, []);

  useEffect(() => {
    const handleClickOutside = () => {
      if (menuOpen) setMenuOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [menuOpen]);

  useEffect(() => setMenuOpen(false), [location.pathname]);

  return (
    <NavbarContainer ref={headerRef} onClick={(e) => e.stopPropagation()}>
      {/* Burger */}
      <BurgerMenu
        onClick={(e) => {
          e.stopPropagation();
          setMenuOpen(!menuOpen);
        }}
      >
        <div />
        <div />
        <div />
      </BurgerMenu>

      {/* Liens desktop */}
      <NavLinks>
        <NavLink to="/" active={location.pathname === "/"}>
          Accueil
        </NavLink>
        <NavLink to="/valeurs" active={location.pathname === "/valeurs"}>
          Nos valeurs
        </NavLink>
        <NavLink
          to="/tarification"
          active={location.pathname === "/tarification"}
        >
          Tarification
        </NavLink>
        <NavLink
          to="/pre-inscription"
          active={location.pathname === "/pre-inscription"}
        >
          Pré-inscription
        </NavLink>
        <NavLink to="/careers" active={location.pathname === "/careers"}>
          Candidature
        </NavLink>
      </NavLinks>

      {/* Menu Mobile */}
      <MobileMenu open={menuOpen} onClick={(e) => e.stopPropagation()}>
        <MobileNavLink to="/">Accueil</MobileNavLink>
        <MobileNavLink to="/valeurs">Nos valeurs</MobileNavLink>
        <MobileNavLink to="/tarification">Tarification</MobileNavLink>
        <MobileNavLink to="/pre-inscription">Pré-inscription</MobileNavLink>
        <MobileNavLink to="/careers">Candidature</MobileNavLink>
      </MobileMenu>
    </NavbarContainer>
  );
};

export default Navbar;
